import { Col, DatePicker, Input, Radio, Row } from 'antd';
import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';


const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;

type PropType = {
    type: string;
    className?: string;
    name: string;
    label?: string;
    items?: any;
    itemsWithInputNumber?: any;
    itemsWithInputBetweenNumber?: any;
    itemsWithInputDate?: any;
    itemsWithInputBetweenDate?: any;
    placeholder?: string;
    value?: any;
    withError?: boolean;
    disabled?: boolean;
    addorn?: any;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
};

function onChange(value: any) {
}

const dateFormat = 'DD/MM/YYYY';

const RadioField = (props: PropType) => (
    <AppContext.Consumer>
        {({ theme, locale }) => (
            <InputWrapper
                theme={theme}
                className={`form-input-wrapper_${props.name} ${props.className || ''}`}
            >
                <RadioGroup onChange={onChange}>
                    {props.items &&
                        props.items.map((item: { value: string; label: string }) => (
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <Radio
                                        key={`${item.value}`}
                                        className={`goepik-component-padding }`}
                                        value={item.value}
                                        name={props.name}
                                        disabled={props.disabled}
                                        onChange={(e: any) => {
                                            e.preventDefault();
                                            if (item.value !== props.value) {
                                              props.setFieldValue(props.name, item.value);
                                              props.setTouched({ [props.name]: true });
                                            }
                                          }}

                                    >
                                        {I18n.l(item.label || '')}

                                    </Radio>
                                </Col>
                            </Row>
                        ))}

                    {props.itemsWithInputNumber &&
                        props.itemsWithInputNumber.map((itemsWithInputNumber: { value: string; label: string }) => (
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <Radio
                                        key={`${itemsWithInputNumber.value}`}
                                        className={`goepik-component-padding }`}
                                        value={itemsWithInputNumber.value}

                                    >
                                        {I18n.l(itemsWithInputNumber.label || '')}
                                        <Input
                                            name={props.name}
                                            // value={props.value}
                                            disabled={props.disabled}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                props.setFieldValue(props.name, e.target.value);
                                                props.setTouched({ [props.name]: true });
                                            }}
                                            style={{ width: '8%' }} size={'small'} />
                                    </Radio>
                                </Col>
                            </Row>
                        ))}

                    {props.itemsWithInputBetweenNumber &&
                        props.itemsWithInputBetweenNumber.map((itemsWithInputBetweenNumber: { value: string; label: string }) => (
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <Radio
                                        key={`${itemsWithInputBetweenNumber.value}`}
                                        className={`goepik-component-padding }`}
                                        value={itemsWithInputBetweenNumber.value}

                                    >
                                        {I18n.l(itemsWithInputBetweenNumber.label || '')}
                                        <Input
                                            style={{ width: '8%' }}
                                            size={'small'}
                                            name={props.name}
                                            // value={props.value}
                                            disabled={props.disabled}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                props.setFieldValue(props.name, e.target.value);
                                                props.setTouched({ [props.name]: true });
                                            }} />
                                        --<Input
                                            style={{ width: '8%' }}
                                            size={'small'}
                                            name={props.name}
                                            // value={props.value}
                                            disabled={props.disabled}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                props.setFieldValue(props.name, e.target.value);
                                                props.setTouched({ [props.name]: true });
                                            }} />
                                    </Radio>
                                </Col>
                            </Row>
                        ))}


                    {props.itemsWithInputDate &&
                        props.itemsWithInputDate.map((itemsWithInputDate: { value: string; label: string }) => (
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <Radio
                                        key={`${itemsWithInputDate.value}`}
                                        className={`goepik-component-padding }`}
                                        value={itemsWithInputDate.value}

                                    >
                                        {I18n.l(itemsWithInputDate.label || '')}<br />
                                        <DatePicker
                                            placeholder={I18n.l('form.taskflowschedule.labels.dateradio')}
                                            format={dateFormat}
                                            onChange={(date: any, dateString: any) => {
                                                props.setFieldValue(props.name, dateString);
                                                props.setTouched({ [props.name]: true });
                                            }} />
                                    </Radio>
                                </Col>
                            </Row>
                        ))}
                    {props.itemsWithInputBetweenDate &&
                        props.itemsWithInputBetweenDate.map((itemsWithInputBetweenDate: { value: string; label: string }) => (
                            <Row>
                                <Col sm={24} md={24} xl={24}>
                                    <Radio
                                        key={`${itemsWithInputBetweenDate.value}`}
                                        className={`goepik-component-padding }`}
                                        value={itemsWithInputBetweenDate.value}

                                    >
                                        {I18n.l(itemsWithInputBetweenDate.label || '')} <br />
                                        <RangePicker
                                            placeholder={I18n.l('form.taskflowschedule.labels.datebetweenradio')}
                                            format={dateFormat}
                                            onChange={(date: any, dateString: any) => {
                                                props.setFieldValue(props.name, dateString);
                                                props.setTouched({ [props.name]: true });
                                            }}
                                        />
                                    </Radio>
                                </Col>
                            </Row>
                        ))}
                </RadioGroup>

            </InputWrapper>
        )}
    </AppContext.Consumer>
);

const InputWrapper = styled.div`
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }
`;

export default RadioField;
